// Deutsche Sprachdatei für Flatpickr
var de = {
    weekdays: {
        shorthand: ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"],
        longhand: [
            "Sonntag", "Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag"
        ]
    },
    months: {
        shorthand: [
            "Jan", "Feb", "Mär", "Apr", "Mai", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Dez"
        ],
        longhand: [
            "Januar", "Februar", "März", "April", "Mai", "Juni",
            "Juli", "August", "September", "Oktober", "November", "Dezember"
        ]
    },
    firstDayOfWeek: 1, // Montag als erster Tag
    ordinal: function () {
        return ".";
    },
    rangeSeparator: " bis ",
    weekAbbreviation: "KW",
    scrollTitle: "Zum Ändern scrollen",
    toggleTitle: "Zum Umschalten klicken",
    amPM: ["AM", "PM"]
};

// Flatpickr mit deutscher Sprache registrieren
if (typeof flatpickr !== "undefined") {
    flatpickr.l10ns.de = de;
}
